import api from "./api"; // use your axios instance

const BASE_URL = "/api/organizations";

const listDocuments = (orgId, projectId, path = "") =>
  api.get(`${BASE_URL}/${orgId}/projects/${projectId}/documents`, {
    params: { path },
  });

const createFolder = (orgId, projectId, parentPath, folderName) =>
  api.post(
    `${BASE_URL}/${orgId}/projects/${projectId}/documents/folder`,
    null,
    { params: { parentPath, folderName } },
  );

const uploadFile = (orgId, projectId, folderPath, file, onProgress) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post(
    `/api/organizations/${orgId}/projects/${projectId}/documents/upload`,
    formData,
    {
      params: { folderPath },
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (event) => {
        if (!event.total) return;
        const percent = Math.round((event.loaded * 100) / event.total);
        onProgress(percent);
      },
    },
  );
};

const deletePath = (orgId, projectId, path) =>
  api.delete(`${BASE_URL}/${orgId}/projects/${projectId}/documents`, {
    params: { path },
  });

const renamePath = (orgId, projectId, oldPath, newName) =>
  api.put(`${BASE_URL}/${orgId}/projects/${projectId}/documents/rename`, null, {
    params: { oldPath, newName },
  });

const movePath = (orgId, projectId, sourcePath, targetPath) =>
  api.put(`${BASE_URL}/${orgId}/projects/${projectId}/documents/move`, null, {
    params: { sourcePath, targetPath },
  });

const copyPath = (orgId, projectId, sourcePath, targetPath) =>
  api.post(`${BASE_URL}/${orgId}/projects/${projectId}/documents/copy`, null, {
    params: { sourcePath, targetPath },
  });

const viewUrl = (orgId, projectId, path) =>
  `${BASE_URL}/${orgId}/projects/${projectId}/documents/view?path=${encodeURIComponent(path)}`;

const downloadUrl = (orgId, projectId, path) =>
  `${BASE_URL}/${orgId}/projects/${projectId}/documents/download?path=${encodeURIComponent(path)}`;

export default {
  listDocuments,
  createFolder,
  uploadFile,
  deletePath,
  renamePath,
  movePath,
  copyPath,
  viewUrl,
  downloadUrl,
};
